import { render } from "./PaymentInfo.vue?vue&type=template&id=4e4e77de&scoped=true"
import script from "./PaymentInfo.vue?vue&type=script&lang=js"
export * from "./PaymentInfo.vue?vue&type=script&lang=js"

import "./PaymentInfo.vue?vue&type=style&index=0&id=4e4e77de&scoped=true&lang=scss"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4e77de"]])

export default __exports__